import { pxToRem } from '../../../../lib';
export default (function (siteVars) {
  return {
    borderColor: siteVars.bodyColor,
    borderWidth: "".concat(pxToRem(1), " ").concat(pxToRem(1), " ").concat(pxToRem(2), " ").concat(pxToRem(1)),
    borderColorFocus: "".concat(siteVars.colors.white, " ").concat(siteVars.colors.white, " ").concat(siteVars.colorScheme.brand.borderFocus1, " ").concat(siteVars.colors.white)
  };
});